export enum LabelPinType {
    Default = 'default',
    PlusMinus = 'plusMinus'
}
